<template>
    <b-modal
        v-if="item && item.exclusao"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Motivo da exclusão')"
        centered
        size="lg"
        @hidden="cancelar"
        id="modal-familia-excluida"
    >
        <load mode="table" v-if="loading" />
        <div v-show="!loading" class="row px-3">
            <h2 class="col-12 px-0">
                {{
                    getTitleArray(
                        parseInt(item.exclusao.motivo_exclusao),
                        motivos
                    )
                }}
            </h2>
            <h4
                class="col-12 px-0"
                v-if="item.exclusao.descricao_motivo_exclusao"
            >
                Descrição
            </h4>
            <p v-html="item.exclusao.descricao_motivo_exclusao"></p>
            <br />
            <h4
                class="col-12 px-0"
                v-if="
                    item.exclusao.certidao_obitos &&
                        item.exclusao.certidao_obitos.length > 0
                "
            >
                Certidões de óbitos
            </h4>
            <div v-if="item.exclusao.certidao_obitos">
                <table
                    class="b-table table table-bordered bg-white b-table-stacked-md"
                    v-for="(obito, i) in item.exclusao.certidao_obitos
                        .familiares"
                    :key="i"
                >
                    <thead>
                        <tr>
                            <td
                                :colspan="
                                    item.exclusao.certidao_obitos.falecimento ==
                                    'a'
                                        ? 7
                                        : 6
                                "
                                v-html="obito.value"
                            ></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="
                                item.exclusao.certidao_obitos.falecimento == 'a'
                            "
                        >
                            <td>
                                Cartório:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .obito_nome_cartorio[i]
                                }}</b>
                            </td>
                            <td>
                                Livro:
                                <b>{{
                                    item.exclusao.certidao_obitos.obito_livro[i]
                                }}</b>
                            </td>
                            <td>
                                Folha:
                                <b>{{
                                    item.exclusao.certidao_obitos.obito_folha[i]
                                }}</b>
                            </td>
                            <td>
                                Número termo:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .obito_numero_termo[i]
                                }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{
                                    item.exclusao.certidao_obitos.obito_uf[i]
                                }}</b>
                            </td>
                            <td>
                                Município:
                                <b>{{
                                    getTitleArray(
                                        item.exclusao.certidao_obitos
                                            .obito_municipio[i],
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .obito_data_emissao[i] | formatDate
                                }}</b>
                            </td>
                        </tr>
                        <tr v-else>
                            <td>
                                Nome Servidor:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .parecer_nome_servidor[i]
                                }}</b>
                            </td>
                            <td>
                                CPF servidor:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .parecer_cpf_servidor[i]
                                }}</b>
                            </td>
                            <td>
                                Número:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .parecer_numero[i]
                                }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{
                                    item.exclusao.certidao_obitos.parecer_uf[i]
                                }}</b>
                            </td>
                            <td>
                                Município:
                                <b>{{
                                    getTitleArray(
                                        item.exclusao.certidao_obitos
                                            .parecer_municipio[i],
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    item.exclusao.certidao_obitos
                                        .parecer_data_emissao[i] | formatDate
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table
                    class="b-table table table-bordered bg-white b-table-stacked-md"
                    v-if="parseInt(item.exclusao.motivo_exclusao) == 8"
                >
                    <tbody>
                        <tr>
                            <td>
                                Nome Servidor:
                                <b>{{ item.exclusao.nome_servidor_parecer }}</b>
                            </td>
                            <td>
                                CPF servidor:
                                <b>{{ item.exclusao.cpf_servidor_parecer }}</b>
                            </td>
                            <td>
                                Número:
                                <b>{{ item.exclusao.num_parecer }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{ item.exclusao.uf_parecer }}</b>
                            </td>
                            <td>
                                Município:
                                <b>{{
                                    getTitleArray(
                                        item.exclusao.munic_parecer,
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    item.exclusao.data_parecer | formatDate
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            motivos: [
                { id: 1, value: "Falecimento de toda familia" },
                { id: 2, value: "Recusa da família em prestar informações" },
                {
                    id: 3,
                    value:
                        "Comprovação de omissão de informações ou prestação de informação inverídicas pela familia"
                },
                { id: 4, value: "Solicitação da familia" },
                { id: 5, value: "Decisão judicial" },
                {
                    id: 6,
                    value: "Familia não localizada para atualização/revalidação"
                },
                {
                    id: 7,
                    value:
                        "Familia com renda per capita acima de 1/2(meio) salário mínimo e renda familiar acima de 3 salários mínimos e que não esteja vinculada a nenhum programa social"
                },
                { id: 8, value: "Averiguação - Suspeita de Fraude" }
            ],
            falecimento: "",
            tipos_falecimento: [
                { id: "a", value: "Certidão de Óbito" },
                {
                    id: "b",
                    value: "Parecer da gestão municipal do cadastro único"
                }
            ],
            municipios: [],
            loading: true
        };
    },
    watch: {
        item() {
            if (this.item && this.item.exclusao) {
                if (!this.item.exclusao.certidao_obitos) {
                    this.loading = false;
                } else {
                    if (this.item.exclusao.certidao_obitos.falecimento == "a") {
                        this.getMunicipios(
                            this.item.exclusao.certidao_obitos.obito_municipio
                        );
                    } else {
                        this.getMunicipios(
                            this.item.exclusao.certidao_obitos.parecer_municipio
                        );
                    }
                    if (this.item.exclusao.munic_parecer) {
                        this.getMunicipios([this.item.exclusao.munic_parecer]);
                    }
                    this.loading = false;
                }
            }
        }
    },
    methods: {
        getTitleArray(valor, array) {
            const result = array.filter(item => item.id == valor);
            return result[0] ? result[0].value : "";
        },
        getMunicipios(cidades) {
            if (cidades) {
                this.loading = true;
                axios
                    .post("api/dashboard/enderecos/get/cidades", {
                        cidades: cidades
                    })
                    .then(response => {
                        this.municipios = response.data;
                        this.loading = false;
                    });
            }
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("modal-familia-excluida");
        }
    }
};
</script>
